import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  channelList: [],
  channelAllList: [],
  channelDetailList: {},
  loading: false,
  error: undefined,
};

const channelSlice = createSlice({
  name: "channel",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchChannelList(state, action) {
      state.channelList = action.payload;
      state.loading = false;
    },
    fetchChannelDetailList(state, action) {
      state.channelDetailList = action.payload;
      state.loading = false;
    },
    fetchClearChannelDetailList(state, action) {
      state.channelDetailList = [];
      state.loading = false;
    },
    fetchAllChannelList(state, action) {
      state.channelAllList = action.payload;
      state.loading = false;
    },
    fetchClearAllChannelList(state, action) {
      state.channelAllList = [];
      state.loading = false;
    },
  },
});

export const channelActions = channelSlice.actions;

export default channelSlice.reducer;
